const e = {
  code: "km",
  facebook: "km_KH",
  label: "ខ្មែរ",
  loadingText: "កំពុងផ្ទុក...",
  translations: {
    ar: "ភាសាអារ៉ាប់",
    de: "ភាសាអាល្លឺម៉ង់",
    en: "ភាសាអង់គ្លេស",
    es: "ភាសាអេស្ប៉ាញ",
    fr: "ភាសាបារាំង",
    he: "ភាសាហេប៊្រូ",
    hi: "ភាសាហិណ្ឌី",
    id: "ភាសាឥណ្ឌូនេស៊ី",
    it: "ភាសាអ៊ីតាលី",
    ja: "ភាសាជប៉ុន",
    km: "ភាសាខ្មែរ",
    ko: "ភាសាកូរ៉េ",
    lo: "ភាសាលាវ",
    ms: "ភាសាម៉ាឡេ",
    nl: "ភាសាហូឡ្លង់",
    pt: "ភាសាព័រទុយហ្កាល់",
    ru: "ភាសារុស្ស៊ី",
    th: "ភាសាថៃ",
    tl: "ភាសាហ្វីលីពីន",
    tr: "ភាសាទួរគី",
    vi: "ភាសាវៀតណាម",
    "zh-CN": "ភាសាចិន (កាត់សម្រួល)",
    "zh-TW": "ភាសាចិន (ពេញលេញ)"
  }
};
export {
  e as khmer
};
